/* Countless Prompt jQuery Plugin - v1.0
 * Copyright (c)2015 Matt Satorius, Sators.com Internet Solutions, Inc.
 * 2015-04-22
 */
(function ( $ ) {
 	var methods = {
        init : function(options) {
			// Default options.
	        var settings = $.extend({
	            // These are the defaults.
	            content: 'Do you want to proceed?',
	            title: 'Caution',
	            icon: 'warning',
	            proceed: ''
	        }, options );

			$(this).each(function(){
				$(this).on('click', function(e){
					e.preventDefault();
					title_text = ($(this).attr('data-prompt-title') ? $(this).attr('data-prompt-title') : settings.title);
					content_text = ($(this).attr('data-prompt-content') ? $(this).attr('data-prompt-content') : settings.content);
					proceed = (settings.proceed.length > 0 ? settings.proceed : $(this).attr('href'));
					icon = ($(this).attr('data-prompt-icon') ? $(this).attr('data-prompt-icon') : settings.icon);
					wrap = $('<div />').addClass('dim-mask').hide();
					prompt = $('<div />').addClass('prompt');

					$('<div />').addClass('title').html('<span class="icon-' + icon + '"></span> ' + title_text).appendTo(prompt);
					$('<div />').addClass('content').html(content_text).appendTo(prompt);
					buttons = $('<div />').addClass('text-right')
					$('<a />').attr('href', proceed).addClass('btn danger').on('click', function(){ $.prompt('remove')}).html('Yes').appendTo(buttons);
					$('<span />').text(' ').appendTo(buttons);
					$('<a />').addClass('btn').html('No').on('click', function(){ $.prompt('remove')}).appendTo(buttons);
					buttons.appendTo(prompt);
					prompt.appendTo(wrap);
					wrap.appendTo($('body')).fadeIn();

				});
			})

			return this;
        },
        remove : function( ) {
	       $('.dim-mask').fadeOut(function(){$(this).remove();});
	    }
    };
    var prompt_function = function(methodOrOptions) {
        if ( methods[methodOrOptions] ) {
            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
        } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
            // Default to "init"
            return methods.init.apply( this, arguments );
        } else {
            $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.prompt' );
        }
    }
    $.fn.prompt = $.prompt = prompt_function;


}( jQuery ));